var moment = require('js/lib/moment');
var translate = require('js/lib/translate');

config.$inject = ['$routeProvider', '$localeProvider', 'pickadateI18nProvider', 'routerProvider'];

function config($routeProvider, $localeProvider, pickadateI18nProvider, routerProvider) {
  routerProvider.$get().config($routeProvider);
  configPickadate($localeProvider, pickadateI18nProvider);
}

function configPickadate($localeProvider, pickadateI18nProvider) {
  pickadateI18nProvider.translations = {
    prev: '<',
    next: '>'
  };

  // Hack to get norwegian month and day names in the calendar
  // (angular-pickadate gets the translations from Angular's $locale service)
  $localeProvider.$get = function() {
    return {
      id: 'nb',

      DATETIME_FORMATS: {
        MONTH: moment.localeData('nb')._months,
        SHORTDAY: moment.localeData('nb')._weekdaysMin
      },

      // Used by the Angular number filter
      NUMBER_FORMATS: {
        DECIMAL_SEP: ',',
        GROUP_SEP: '\u00a0',
        PATTERNS: [{
          lgSize: 3,
          negPre: '-',
          negSuf: '',
          posPre: '',
          posSuf: ''
        }]
      }
    };
  };
}

run.$inject = ['$document', '$rootScope', 'login', 'storage', 'config'];

function run($document, $rootScope, login, storage, config) {
  login.checkAuth();

  login.initLanguage();

  $rootScope.t = translate.t; // Set global i18n-method
  $rootScope.tu = translate.tu; // Set global i18n-method

  // Hack to enable click events on any element in iOS
  $document.one('touchstart', function() {
    $document.find('body').css('cursor', 'pointer');
  });
}

module.exports = {
  constant: {
    languages: [
      { id: 'en', name: 'English' },
      { id: 'nb', name: 'Norsk' },
      { id: 'fr', name: 'Français' },
      { id: 'sv', name: 'Svenska' },
      //{ id: 'fi', name: 'Suomalainen' }
    ],
    // This has to match the CSS! (variables.styl)
    routeColors: [
      '#479ff6',
      '#d9441d',
      '#772cb5',
      '#21897e',
      '#e27012',
      '#447db5',
      '#4ec2d3',
      '#f6c347',
      '#07529c',
      '#6C210f',
      '#411863',
      '#4ad3c6',
      '#f2b27b',
      '#89add2',
      '#8dd7e2',
      '#fae09e'
    ]
  },
  config: config,
  run: run
};

window.HW_config = {
  selector: '#HW_wrapper',
  account: 'wx84nx',
  translations: {
    title: 'Siste endringer',
    readMore: 'Les mer'
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/config.js
 ** module id = 10
 ** module chunks = 1
 **/